import React from 'react';
import { toast } from 'react-toastify';
import ToastDialog from './ToastDialog';

const TOAST_DURATION = 3000;
const TOAST_CLASS_NAME = 'spotlight-action-toast-shell';
const TOAST_BODY_CLASS_NAME = 'spotlight-action-toast-body';
const GLOBAL_ERROR_TOAST_ID = 'spotlight-global-error';
const toastTimers = new Map();

const scheduleDismiss = (id, autoClose) => {
  const existingTimer = toastTimers.get(id);
  if (existingTimer) window.clearTimeout(existingTimer);

  const timer = window.setTimeout(() => {
    toast.dismiss(id);
    toastTimers.delete(id);
  }, autoClose);

  toastTimers.set(id, timer);
};

const showSpotlightToast = ({
  active = true,
  autoClose = TOAST_DURATION,
  onClose,
  toastId,
  type = 'success',
  ...toastDialogProps
}) => {
  const id = toastId || (type === 'error' ? GLOBAL_ERROR_TOAST_ID : `spotlight-${type}-${Date.now()}`);
  const content = <ToastDialog active={active} type={type} {...toastDialogProps} />;
  const options = {
    autoClose,
    bodyClassName: TOAST_BODY_CLASS_NAME,
    className: TOAST_CLASS_NAME,
    draggable: true,
    hideProgressBar: true,
    onClose,
    pauseOnFocusLoss: false,
    pauseOnHover: false,
    position: toast.POSITION.BOTTOM_RIGHT,
    toastId: id,
  };

  if (toast.isActive(id)) {
    toast.update(id, {
      ...options,
      render: content,
    });
  } else {
    toast(content, options);
  }

  // Reusing a single error toast id means a new error replaces the previous
  // one instead of stacking multiple error cards. Reset the fallback timeout
  // each time the same error toast is updated.
  scheduleDismiss(id, autoClose);

  return id;
};

export default showSpotlightToast;
